import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { PackagingApiAdapter } from '../adapters/PackagingApiAdapter';
import type { BoxGroupCategory } from '../models/Packaging';

interface UsePackagingBoxGroupsOptions {
  teamId?: number | null;
  enabled?: boolean;
  boxCategory?: BoxGroupCategory;
}

const PACKAGING_BOX_CATEGORY: BoxGroupCategory = 'customer_box';

export const usePackagingBoxGroups = ({
  teamId,
  enabled = true,
  boxCategory = PACKAGING_BOX_CATEGORY,
}: UsePackagingBoxGroupsOptions = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PackagingApiAdapter(httpClient);

  const { data, isLoading, error } = useQuery({
    queryKey: ['packaging-box-groups', teamId ?? 'no-team', boxCategory],
    queryFn: () => apiAdapter.getBoxGroups(teamId ?? undefined, boxCategory),
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    boxGroups: data ?? [],
    isLoading,
    error,
  };
};
